module.exports = __webpack_public_path__ + "static/media/layout7-img.329a39c9.svg";